import forge from 'apis/forge';
import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { NEW_CHAT_TITLE } from 'dragonmouse-shared/constants';
import { CHAT_COLUMN_GAP, ChatStatus } from 'dragonmouse-shared/interfaces';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectActiveScene } from 'redux/db/reducers';
import { canEdit, getRightmostFrameX } from 'redux/db/util';
import { setActiveSceneChatId } from 'redux/mode/actions';
import { displayViewOnlyModal } from 'redux/mode/util';
import { RootReducer } from 'redux/reducers';
import { v4 as uuid } from 'uuid';

interface Props {
	isMobile?: boolean;
}

const SceneNewChatAction = ({ isMobile }: Props) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const activeScene = useSelector((r: RootReducer) =>
		selectActiveScene(r.db, r.mode.activeSceneId)
	);

	const onClick = async () => {
		if (!activeScene || isLoading) return;

		if (!canEdit(activeScene)) {
			displayViewOnlyModal();
			return;
		}

		const chatId = uuid();
		const rightmostFrameX = getRightmostFrameX();
		setIsLoading(true);

		try {
			await forge.createSceneChat({
				id: chatId,
				sceneId: activeScene.id,
				title: NEW_CHAT_TITLE,
				x: rightmostFrameX !== null ? rightmostFrameX + CHAT_COLUMN_GAP : 0,
				y: 0,
				metadata: { status: ChatStatus.PROCESSING, statusMessage: 'Initializing chat...' },
			});
			dispatch(setActiveSceneChatId(chatId));
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<ActionButton
			icon={IconType.CHAT_NEW}
			label="Start a fresh chat"
			loadingLabel="Creating new chat..."
			isLoading={isLoading}
			isMobile={isMobile}
			onClick={onClick}
		/>
	);
};

export default SceneNewChatAction;
